export default {
    selectIntoTable:{
        top:-3,
        margin: '0px 1px 0px 0px !important'
    },
    tableActions:{
        float:'right',
        '& button':{
            marginRight:10,
            height:30,
            width:30
        }
    },
    inputIntoTable:{
        paddingTop:0,
        marginBottom:0,
        top: -5
    }
}


// WEBPACK FOOTER //
// ./src/assets/jss/material-dashboard-pro-react/components/table.jsx